<template>
  <v-tooltip activator="parent" location="bottom" class="info-button">
      <info-study-word></info-study-word>
  </v-tooltip>
</template>

<script setup>
import InfoStudyWord from "@/components/modals/shared/InfoStudyWord";
</script>

<style lang="scss">
.info-button.v-tooltip > .v-overlay__content {
  display: flex;
  background-color: var(--pink) !important;
  opacity: 0.95;
  color: var(--light-yellow) !important;
  border-radius: 10px;
  border: 1px solid var(--dark);
  padding: 15px;
}
</style>
